"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var d3array = require("d3-array");
var models_1 = require("./models");
var Accessor_1 = require("./models/Accessor");
var DataTable_1 = require("./models/DataTable");
exports.getLatestValue = function (table, accessor) {
    if (accessor === void 0) { accessor = Accessor_1.DefaultMeasureAccessor; }
    if (table && table.length) {
        for (var i = table.length - 1; i > -1; i--) {
            var point = table[i];
            var value = accessor(point);
            if (!DataTable_1.isNullOrUndefined(value)) {
                return point;
            }
        }
    }
    return undefined;
};
exports.mapRolesToValues = function (roles, value, comparison) {
    return roles
        .map(function (role) {
        switch (role) {
            case models_1.MetricValueRole.CURRENT:
                return { role: role, value: value };
            case models_1.MetricValueRole.ABSOLUTE_CHANGE:
                return comparison ? { role: role, value: comparison.absolute } : undefined;
            case models_1.MetricValueRole.PERCENTAGE_CHANGE:
                return comparison ? { role: role, value: comparison.percentage } : undefined;
            default:
                return undefined;
        }
    })
        .filter(function (element) { return element !== undefined; });
};
exports.parseDateTrunc = function (qualifiedName) {
    // Note: This function _must_ be kept in sync with the server version.
    // https://gitlab.tableausoftware.com/metrics/service/gateway/metrics-gateway-service/-/blob/master/src/main/kotlin/com/tableau/metrics/gateway/grpc/p4/ColumnNameExtractor.kt
    // Qualified names look like this:
    // [dataengine.42019.618651678240].[tyr:Order Date:qk]
    // For Date Trunc fields, the `tyr` there is what we're looking for.
    // Take a look at http://l/datetruncs for more info.
    var regex = /\.\[(.{2,4})\:/;
    // That is:
    // \. a literal period
    // \[ a literal open square brace
    // (.{2,4}) capture 2 to 4 characters
    // \: a literal colon
    var match = regex.exec(qualifiedName);
    if (match) {
        switch (match[1]) {
            case 'tyr':
                return models_1.DateTrunc.YEAR;
            case 'tqr':
                return models_1.DateTrunc.QUARTER;
            case 'tmn':
                return models_1.DateTrunc.MONTH;
            case 'tdy':
                return models_1.DateTrunc.DAY;
            case 'thr':
                return models_1.DateTrunc.HOUR;
            case 'tmi':
                return models_1.DateTrunc.MINUTE;
            case 'tsc':
                return models_1.DateTrunc.SECOND;
            case 'twk':
                return models_1.DateTrunc.WEEK;
            case 'tiyr':
                return models_1.DateTrunc.ISO_YEAR;
            case 'tiqr':
                return models_1.DateTrunc.ISO_QTR;
            case 'tiwk':
                return models_1.DateTrunc.ISO_WEEK;
            case 'tiwd':
                return models_1.DateTrunc.ISO_WEEKDAY;
            case 'yr':
                return models_1.DateTrunc.YEAR;
            case 'qr':
                return models_1.DateTrunc.QUARTER;
            case 'mn':
                return models_1.DateTrunc.MONTH;
            case 'dy':
                return models_1.DateTrunc.DAY;
            case 'hr':
                return models_1.DateTrunc.HOUR;
            case 'mi':
                return models_1.DateTrunc.MINUTE;
            case 'sc':
                return models_1.DateTrunc.SECOND;
            case 'wk':
                return models_1.DateTrunc.WEEK;
            case 'iyr':
                return models_1.DateTrunc.ISO_YEAR;
            case 'iqr':
                return models_1.DateTrunc.ISO_QTR;
            case 'iwk':
                return models_1.DateTrunc.ISO_WEEK;
            case 'iwd':
                return models_1.DateTrunc.ISO_WEEKDAY;
            default:
                return models_1.DateTrunc.UNKNOWN;
        }
    }
    return models_1.DateTrunc.UNKNOWN;
};
exports.getComparisonDateRange = function (data) {
    var _a = d3array.extent(data, function (p) { return p.comparisonTimestamp; }), first = _a[0], last = _a[1];
    if (first && last) {
        return { first: first, last: last };
    }
    return undefined;
};
//# sourceMappingURL=engine.js.map